import * as React from 'react'
import { Check, ChevronsUpDown } from 'lucide-react'
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { Button } from '@/components/ui/button'
import { useVendors } from '@/hooks/useVendors'
import { cn } from '@/lib/utils'

interface Props {
  value: string
  onChange: (v: string) => void
  disabled?: boolean
  id?: string
}

export function VendorCombobox({ value, onChange, disabled, id }: Props) {
  const [open, setOpen] = React.useState(false)
  const { data: vendors = [], isLoading } = useVendors()

  return (
    <Popover open={open} onOpenChange={setOpen} modal>
      <PopoverTrigger asChild>
        <Button
          id={id}
          type="button"
          variant="outline"
          role="combobox"
          aria-expanded={open}
          disabled={disabled}
          className="w-full justify-between"
        >
          {value || (isLoading ? 'Loading vendors…' : 'Select vendor…')}
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[var(--radix-popover-trigger-width)] p-0" align="start">
        <Command>
          <CommandInput placeholder="Search vendors…" />
          <CommandList>
            <CommandEmpty>No vendor found.</CommandEmpty>
            <CommandGroup>
              {vendors.map((v) => (
                <CommandItem
                  key={v.vendor}
                  value={v.vendor}
                  onSelect={() => {
                    onChange(v.vendor)
                    setOpen(false)
                  }}
                >
                  <Check
                    className={cn(
                      'mr-2 h-4 w-4',
                      value === v.vendor ? 'opacity-100' : 'opacity-0'
                    )}
                  />
                  {v.vendor}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  )
}
